module.exports = __webpack_public_path__ + "static/media/LAT3170.0a2bfa01.pdf";